export default __webpack_public_path__ + "fonts/Gotham-Medium.eb277d2d77a5fab12a58c15a111da075.svg";